import * as yup from 'yup';
import { setIn } from 'final-form';
import simpleMemoize from "./SimpleMemoize";

// Example schema
const validationSchema = yup.object({
    email: yup.string().email(),
    shipping: yup.object({
        name: yup.string(),
        phone: yup.object({
            code: yup.string().matches(/^\+\d+$/i),
            number: yup.number().max(10),
        }),
        address: yup.string(),
        zip: yup.string(),
    }),
    billing: yup.object({
        name: yup.string(),
        address: yup.string(),
        zip: yup.string(),
    }),
    items: yup.array().of(
        yup.object({
            id: yup.number(),
            price: yup.number(),
            quantity: yup.number(),
        })
    ),
});

// This is what you want... To be passed to React Final Form
export const yupValidate = simpleMemoize((schema) => async (values) => {
    console.log('Validating form', {values});
    if (typeof schema === 'function') {
        schema = schema();
    }
    try {
        await schema.validate(values, { abortEarly: false });
    } catch (err) {
        const errors = err.inner.reduce((formError, innerError) => {
            return setIn(formError, innerError.path, innerError.message);
        }, {});

        return errors;
    }
});

// Example usage
//yupValidateFormValues(validationSchema)

export default yupValidate;

